import { Component } from "react";

export const objectsDeepEqual = (object1, object2, compareFunctions = true) => {
  // Handle null and undefined values
  if (
    [object1, object2].indexOf(null) >= 0 ||
    [object1, object2].indexOf(undefined) >= 0
  ) {
    return Boolean(object1) === Boolean(object2);
  }
  // Make sure we have the same number of keys for both objects
  if (Object.keys(object1).length !== Object.keys(object2).length) {
    return false;
  }
  for (let key in object1) {
    switch (typeof object1[key]) {
      case "object":
        if (!objectsDeepEqual(object1[key], object2[key], compareFunctions)) {
          return false;
        }
        break;
      case "function":
        if (compareFunctions && object1[key] !== object2[key]) {
          return false;
        }
        break;
      default:
        if (object1[key] !== object2[key]) {
          return false;
        }
        break;
    }
  }
  // If we got through all of the items in these objects without finding differences, they were
  // equal
  return true;
};

// This is a custom react component we built to add some logic to the "shouldComponentUpdate"
// function.
//
// Instead of blindly and always returning `true` (which is what react's base `Component`) does, or
// only doing a shallow comparison of properties and state (which is what react `PureComponent`)
// does, we do a deep comparison of properties and state, ignoring functions (since those are
// difficult to compare properly, and shouldn't really change for a component anyways), and only
// return `true` if there is some difference.

export default class SmartComponent extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    // If everything is equal, we do *not* want to update this component
    return !(
      objectsDeepEqual(nextProps, this.props, false) &&
      objectsDeepEqual(nextState, this.state, false)
    );
  }
}
